/**
 * useAutoplay Hook
 *
 * Manages autoplay functionality for mfersbeheaded game.
 * Extracted from Board.js as part of refactoring effort.
 *
 * @param {boolean} AUTOPLAY - Whether autoplay is enabled
 * @param {number} AUTOPLAY_INTERVAL_MS - Interval between autoplay actions
 * @param {Array} board - The game board
 * @param {Object} selectedJewel - Currently selected jewel
 * @param {string} gameState - Current game state
 * @param {Function} findSwapForMatch - Function to find a valid swap
 * @param {Function} handleJewelClicked - Function to handle jewel click
 */

import { useState, useEffect } from 'react';
import CONSTANTS from '../constants';

export const useAutoplay = (
  AUTOPLAY,
  AUTOPLAY_INTERVAL_MS,
  board,
  selectedJewel,
  gameState,
  findSwapForMatch,
  handleJewelClicked
) => {
  const [bit, setBit] = useState(false);

  // Bit flip for autoplay timing
  useEffect(() => {
    const intervalId = setInterval(() => {
      setBit((prevBit) => !prevBit);
    }, CONSTANTS.TIMING.BIT_FLIP_INTERVAL);

    return () => clearInterval(intervalId);
  }, []);

  // Autoplay logic
  useEffect(() => {
    if (!AUTOPLAY) {
      return;
    }

    const timerId = setTimeout(() => {
      const output = findSwapForMatch(board, selectedJewel);

      if (gameState === CONSTANTS.GAME_STATE_IN_PROGRESS) {
        if (output === null) {
          // No valid moves found
        } else {
          handleJewelClicked(output.row, output.col);
        }
      }
    }, AUTOPLAY_INTERVAL_MS);

    return () => {
      clearTimeout(timerId);
    };
  }, [board, selectedJewel, gameState, bit, AUTOPLAY, AUTOPLAY_INTERVAL_MS, findSwapForMatch, handleJewelClicked]);

  return {
    bit,
  };
};

export default useAutoplay;
